export type Accelerator =
  | "gpu"
  | "tpu_v3_8"
  | "tpu_v2_32"
  | "tpu_v2_256"
  | "none";

export function isAccelerator(input: string): input is Accelerator {
  return (
    input === "gpu" ||
    input === "tpu_v3_8" ||
    input === "tpu_v2_32" ||
    input === "tpu_v2_256" ||
    input === "none"
  );
}

export function acceleratorTypeToQuotaType(
  accelerator: "gpu" | "tpu_v3_8" | "tpu_v2_32" | "tpu_v2_256"
): "gpu" | "tpu" {
  if (isTpuAccelerator(accelerator)) {
    return "tpu";
  }
  return "gpu";
}

export const isTpuAccelerator = (accelerator: string | undefined) => {
  return (
    accelerator === "tpu_v3_8" ||
    accelerator === "tpu_v2_32" ||
    accelerator === "tpu_v2_256"
  );
};
